/* eslint-disable indent */
/* eslint-disable no-underscore-dangle */
import produce from 'immer';

import {
  FETCH_COMPANY_CONTRACTS,
  FETCH_COMPANY_CONTRACTS_FAILED,
  FETCH_COMPANY_CONTRACTS_SUCCESS,
  FETCH_CONTRACTS,
  FETCH_CONTRACTS_FAILED,
  FETCH_CONTRACTS_SUCCESS,
  UPDATE_CONTRACT_SUCCESS,
} from 'actions/contractActions';

export const initialState = {
  contractsFetching: false,
  contractsFetchSuccess: false,
  contractsFetchFailed: false,
  companyContractsFetching: false,
  companyContractsFetchSuccess: false,
  companyContractsFetchFailed: false,
  contracts: [],
  companyContracts: [],
  total: 0,
  pageNumberBack: 0,
};

/* eslint-disable default-case, no-param-reassign */
const contractReducer = (state = initialState, action) =>
  // eslint-disable-next-line consistent-return
  produce(state, (draft) => {
    switch (action.type) {
      case FETCH_CONTRACTS:
        draft.contractsFetching = true;
        draft.contractsFetchSuccess = false;
        draft.contractsFetchFailed = false;
        draft.contracts = [];
        draft.total = 0;
        draft.pageNumberBack = 0;
        break;

      case FETCH_CONTRACTS_SUCCESS:
        draft.contractsFetching = false;
        draft.contractsFetchSuccess = true;
        draft.contractsFetchFailed = false;
        draft.contracts = action.details.contracts;
        draft.total = action.details.total;
        draft.pageNumberBack = action.details.pageNumberBack;
        break;

      case FETCH_CONTRACTS_FAILED:
        draft.contractsFetching = false;
        draft.contractsFetchSuccess = false;
        draft.contractsFetchFailed = false;
        draft.contracts = [];
        draft.total = 0;
        draft.pageNumberBack = 0;
        break;

      case FETCH_COMPANY_CONTRACTS:
        draft.companyContractsFetching = true;
        draft.companyContractsFetchSuccess = false;
        draft.companyContractsFetchFailed = false;
        draft.total = 0;
        draft.pageNumberBack = 0;
        break;

      case FETCH_COMPANY_CONTRACTS_SUCCESS:
        draft.companyContractsFetching = false;
        draft.companyContractsFetchSuccess = true;
        draft.companyContractsFetchFailed = false;
        draft.companyContracts = action.details.contracts;
        draft.total = action.details.total;
        draft.pageNumberBack = action.details.pageNumberBack;
        break;

      case FETCH_COMPANY_CONTRACTS_FAILED:
        draft.companyContractsFetching = false;
        draft.companyContractsFetchSuccess = false;
        draft.companyContractsFetchFailed = false;
        draft.companyContracts = [];
        draft.total = 0;
        draft.pageNumberBack = 0;
        break;

      case UPDATE_CONTRACT_SUCCESS:
        draft.contracts = draft.contracts.map((contract) =>
          action.contract._id === contract._id
            ? {...contract, ...action.contract}
            : contract
        );
    }
  });

export default contractReducer;
